import StockModal from "./StockModal";
export default StockModal;